module.exports = __webpack_public_path__ + "static/media/avatar11.c5c4e937.jpg";